import { useState, useEffect } from 'react';
import imgTournoi1 from '../assets/images/img-tournoi-1.png';
import imgTournoi2 from '../assets/images/img-tournoi-2.png';
import imgTournoi3 from '../assets/images/img-tournoi-3.png';
import imgTournoi4 from '../assets/images/img-tournoi-4.png';
//import imgTournoi5 from '../assets/images/img-tournoi-5.png';
import imgTournoi6 from '../assets/images/img-tournoi-6.png';
//import imgTournoi7 from '../assets/images/img-tournoi-7.png';
//import imgTournoi8 from '../assets/images/img-tournoi-8.png';
import imgTournoi9 from '../assets/images/img-tournoi-9.png';

const VignetteTournoi = () => {
  const [selectedImage, setSelectedImage] = useState('');

  // Tableau des images disponibles
  const images = [imgTournoi1, imgTournoi2, imgTournoi3, 
    imgTournoi4, imgTournoi6, imgTournoi9];

  // Fonction pour sélectionner une image aléatoire
  const getRandomImage = () => {
    const randomIndex = Math.floor(Math.random() * images.length);
    return images[randomIndex];
  };

  // Sélectionner une image au chargement du composant
  useEffect(() => {
    setSelectedImage(getRandomImage());
  }, []);

  return (
    <div
      className="hidden md:block h-44 bg-cover bg-center transition-all duration-300"
      style={{ backgroundImage: `url(${selectedImage})` }} />
      
  );
};

export default VignetteTournoi;